import type {
  EquipmentType,
  EquipmentTypeApi,
  EquipmentTypeFilters,
  EquipmentTypeFiltersUpdateApi,
  EquipmentTypes,
  EquipmentTypesApi,
} from '../../models';
import { inlineSearch, paginate } from '../normalize';

export const normalizeEquipmentType = (equipmentType: EquipmentTypeApi): EquipmentType => ({
  ...equipmentType,
  label: equipmentType.description,
});

export const normalizeEquipmentTypes = (response: EquipmentTypesApi): EquipmentTypes => {
  const list = (response.items ?? []).map(normalizeEquipmentType);
  return {
    list,
    map: list.reduce(
      (acc, equipmentType) => {
        acc[String(equipmentType.id)] = equipmentType;
        return acc;
      },
      {} as EquipmentTypes['map'],
    ),
  };
};

export const normalizeEquipmentTypeFilters = (
  filters: Partial<EquipmentTypeFilters>,
): EquipmentTypeFiltersUpdateApi => {
  const { search, ...otherFilters } = filters;
  return {
    ...inlineSearch(search),
    ...inlineSearch(otherFilters),
    ...paginate(otherFilters),
  };
};
